<template>
    <ModalWindow
        ref="modal_component"
        :section_state="meo_cloud_controller.section_state"
        section_state_id="meo_cloud"
        class="attach-modal cloud"
        title="composer.meocloud.attachments_meo"
        @errorRetry="onErrorRetry()"
        >
            <template #pre-body v-if="meo_cloud_controller.data.authorized === true">
                <div class="cloud-search">
                    <div class="search-input">
                        <div class="control-group">
                            <div class="control" role="search">
                                <input
                                    type="text"
                                    v-model="search_term"
                                    :placeholder="Language.say('composer.meocloud.search')"
                                    @keypress.enter="onSearch()"
                                >

                                <ActionButton v-if="meo_cloud_controller.data.metadata.search"
                                    @click="onClearSearch()"
                                    icon='fas fa-times'
                                    class="clear"
                                />

                                <DropdownList v-if="type !== 'attachment_upload'">
                                    <template #select>
                                        <ActionButton
                                            icon='fas fa-chevron-down'
                                            class="outline"
                                        />
                                    </template>

                                    <template #options>
                                        <slot name="actions">
                                            <ActionButton
                                                @click="onToggleSearchCriteria('all')"
                                                :class="{active: search_criteria === 'all'}"
                                                text='composer.meocloud.search_all'
                                            />
                                            <ActionButton
                                                @click="onToggleSearchCriteria('this_folder')"
                                                :class="{active: search_criteria === 'this_folder'}"
                                                text='composer.meocloud.search_current'
                                            />
                                        </slot>
                                    </template>
                                </DropdownList>

                                <button
                                    @click="onSearch()"
                                    type="submit"
                                >
                                    <i class="fas fa-search"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="actions">
                        <ActionButton
                            @click="onAddFolderToggle()"
                            icon='fas fa-plus-circle'
                            text="composer.meocloud.create_folder"
                        />
                        <ActionButton  v-if="type !== 'attachment_upload'"
                            @click="onTriggerUpload()"
                            icon='fas fa-cloud-upload-alt'
                            text="composer.meocloud.upload"
                            :loading="meo_cloud_controller.uploads.total > 0 && meo_cloud_controller.uploads.finished === false"
                            :disabled="meo_cloud_controller.uploads.total > 0 && meo_cloud_controller.uploads.finished === false"
                        />
                        <!-- class="file-view list"-->
                        <!--v-tooltip='"composer.modals.list_view"'-->
                        <!-- <ActionButton
                            icon='fas fa-th'
                            class="file-view grid"
                            v-tooltip='"composer.meocloud.grid_view"'
                        /> -->

                        <input
                            @change="onFilesUpload"
                            ref="meocloud_upload_input"
                            id="meoCloudFileUpload"
                            type="file"
                            hidden
                            multiple
                        >
                    </div>
                </div>

                <div class="create-folder" v-if="folder_create_visible">
                    <div class="form">
                        <fieldset>
                            <div class="control-group">
                                <div class="control">
                                    <label for="new_folder_name">
                                        {{Language.say('composer.meocloud.create_folder')}}
                                    </label>
                                    <div class="close" @click="onAddFolderToggle()"><span></span></div>
                                    <span class="attach-button">
                                        <input
                                        v-focus="true"
                                        v-model="new_folder_name"
                                        @keyup.enter="onAddFolderSubmit()"
                                        id="new_folder_name" type="text"
                                        >
                                        <ActionButton
                                            @click="onAddFolderSubmit()"
                                            icon="fas fa-check"
                                            class='main-action'
                                            text="global.actions.submit"
                                            :disabled="!new_folder_name"
                                            :loading='meo_cloud_controller.saving_state.saving["create_folder"]'
                                        />
                                    </span>
                                </div>
                            </div>
                    </fieldset>
                    </div>
                </div>

                <ul class="cloud-folder-nav">
                    <li>
                        <span v-if="meo_cloud_controller.data.metadata.split_path.length"
                            @click="onFolderClick('/')"
                            role="button"
                        >
                            {{Language.say('composer.meocloud.home')}}
                        </span>

                        <span v-else>
                            {{Language.say('composer.meocloud.home')}}
                        </span>
                    </li>
                    <li v-for="item in meo_cloud_controller.data.metadata.split_path" :key="item.path">
                        <span
                            @click="onFolderClick(item.path)"
                            role="button">{{ item.name }}
                        </span>
                    </li>
                </ul>

            </template>

            <template #body v-if="meo_cloud_controller.data.authorized === true">
                <ul class="drop-list" v-if="meo_cloud_controller.uploads.total && meo_cloud_controller.uploads.finished === false">
                    <li>
                        <div>
                            <span role="button">
                                {{ meo_cloud_controller.uploads.event.file.name}}
                            </span>
                            <small>
                                {{ meo_cloud_controller.uploads.event.size_text }}
                                <slot v-if="meo_cloud_controller.uploads.total > 1">
                                    ({{ meo_cloud_controller.uploads.current }} / {{meo_cloud_controller.uploads.total}})
                                </slot>
                            </small>
                            <div class="progress-bar">
                                <span
                                class="fill"
                                :style="'width:' + meo_cloud_controller.uploads.event.progress_percentage  + '%'"
                                >
                                </span>
                            </div>
                        </div>
                        <ActionButton
                            @click="onAbortUpload"
                            icon='fas fa-times-circle'
                            class='clear push-right'
                        />
                    </li>
                </ul>

                <!--  class="file-list grid-view"-->
                <div class="file-list list-view">
                    <ComposeAttachmentsMeoCloudFiles v-if="meo_cloud_controller.uploaded_files.length"
                        :file_selection="file_selection"
                        :files="meo_cloud_controller.uploaded_files"
                        @fileClick="onFileClick"
                        @folderClick="onFolderClick"
                    />

                    <ComposeAttachmentsMeoCloudFiles v-if="meo_cloud_controller.data.metadata.contents.length"
                        :file_selection="file_selection"
                        :files="meo_cloud_controller.data.metadata.contents"
                        @fileClick="onFileClick"
                        @folderClick="onFolderClick"
                    />

                    <ContentEmpty v-if="!meo_cloud_controller.data.metadata.contents.length && !meo_cloud_controller.uploaded_files.length"
                        :text="(type === 'attachment_upload') ? 'composer.meocloud.upload_here' : 'composer.meocloud.empty_folder'"
                        icon='fas fa-folder-open'
                    />
                </div>
            </template>

            <template #body v-else>
                <div class="padding">
                    <h3>{{Language.say('composer.meocloud.authorize.text_1')}}</h3>

                    <p>
                        {{Language.say('composer.meocloud.authorize.text_2')}}
                    </p>

                    <h3 class="top-space">
                        <span>
                            {{Language.say('composer.meocloud.authorize.text_3')}}
                        </span>

                        <a :href="config.host" target="_blank">
                            {{Language.say('composer.meocloud.authorize.text_3_link')}}
                        </a>

                        <span>
                            {{Language.say('composer.meocloud.authorize.text_3_pos_link')}}
                        </span>
                    </h3>

                    <p>
                        {{Language.say('composer.meocloud.authorize.text_4')}}
                    </p>
                </div>

            </template>

            <template #footer v-if="meo_cloud_controller.data.authorized === true">
                <ActionButton @click="onRemoveAuthorization()" class='underline' text="composer.meocloud.remove_consent" />

                <template v-if="type !== 'attachment_upload'">
                    <small>{{Language.say('composer.meocloud.expire_link')}}</small>

                    <DropdownList>
                        <template #select>
                            <ActionButton class='outline' :text="`composer.meocloud.${link_expiration}`" />
                        </template>

                        <template #options>
                            <ActionButton @click="onChangeExpiration('forever')" :class="{active : link_expiration === 'forever' }" text='composer.meocloud.forever'/>
                            <ActionButton @click="onChangeExpiration('1d')"      :class="{active : link_expiration === '1d' }"      text='composer.meocloud.1d'/>
                            <ActionButton @click="onChangeExpiration('30d')"     :class="{active : link_expiration === '30d' }"     text='composer.meocloud.30d'/>
                            <ActionButton @click="onChangeExpiration('90d')"     :class="{active : link_expiration === '90d' }"     text='composer.meocloud.90d'/>
                        </template>
                    </DropdownList>
                </template>

                <ActionButton v-if="type !== 'attachment_upload'"
                    @click="onAddFilesToComposer()"
                    class='main-action push-right'
                    text="composer.modals.embed_email"
                    :disabled="!file_selection.count"
                    :loading="meo_cloud_controller.saving_state.saving['get_shared_links']"
                />

                <ActionButton v-else-if="type === 'attachment_upload'"
                    @click="onAddFilesToMeoCloud()"
                    class='main-action push-right'
                    text="composer.meocloud.modals.save_to_cloud"
                    :loading="meo_cloud_controller.saving_state.saving['meo_cloud_attachment_upload']"
                />
            </template>

            <template #footer v-else>
                <ActionButton
                    text="global.actions.cancel"
                />
                <ActionButton v-if="!meo_cloud_controller.section_state.error['meo_cloud']"
                    class='main-action push-right'
                    text='composer.meocloud.authorize.button'
                    @click="onOpenAuthorization()"
                />
            </template>
    </ModalWindow>
</template>


<script setup>
  import {ref, reactive}                 from "vue";
  import {onBeforeMount, onUnmounted}    from "vue";
  import {defineProps}                   from "vue";
  import ComposeAttachmentsMeoCloudFiles from "./ComposeAttachmentsMeoCloudFiles.vue";
  import ModalWindow                     from '@/vue/Layouts/Modals/ModalWindow.vue';
  import DropdownList                    from '@/vue/Elements/DropDowns/DropdownList.vue';
  import ActionButton                    from '@/vue/Elements/Buttons/ActionButton.vue';
  import ContentEmpty                    from "@/vue/Elements/Content/ContentEmpty.vue";
  import FilesEventManager               from "@/js/Shared/Events/Managers/FilesEventManager";
  import CollectionList                  from "@/js/Shared/Collections/CollectionList.js";
  import Language                        from '@/js/Shared/Language/Language.js';
  import SAPOMailConfig                  from "@/SAPOMailConfig";


  const file_selection        = reactive(new CollectionList('rev'));
  const search_criteria       = ref('all');
  const meocloud_upload_input = ref();
  const search_term           = ref();
  const new_folder_name       = ref();
  const folder_create_visible = ref();
  const modal_component       = ref();
  const link_expiration       = ref('forever');
  const config                = SAPOMailConfig.server.meocloud;
  const get_type              = ref();

  const props = defineProps({
    meo_cloud_controller : {
        required: true,
    },

    meo_cloud_attachment: {
        default: null,
    },

    compose_controller : {
        default: null,
    },

    type : {
        default: 'compose'
    }
  })

  const emit = defineEmits([
    'addFilesToComposer'
  ])

  onBeforeMount(async () => {
    get_type.value = (props.type === 'attachment_upload') ? 'folders' : 'full';

    window.addEventListener('storage', onWindowMessage);
    await props.meo_cloud_controller.getCloudData(get_type.value);
  });

  onUnmounted(() => {
    window.removeEventListener('storage', onWindowMessage);
  });

  const onErrorRetry = async () => {
    await props.meo_cloud_controller.getCloudData(get_type.value );
  }

  const onAddFolderToggle = () => {
    setFolderCreateVisibilty(!folder_create_visible.value);
  }

  const onAddFolderSubmit = async () => {
    if (!new_folder_name.value) {
      return;
    }

    await props.meo_cloud_controller.createFolder(new_folder_name.value);
    setFolderCreateVisibilty(false);
    setSearchTerm(null);
    setNewFolderName(null);
    await props.meo_cloud_controller.browseNewFolder();
  }

  const onTriggerUpload = () => {
    meocloud_upload_input.value.click();
  }

  const onFilesUpload = async (event) => {
    await props.meo_cloud_controller.addFiles(
      FilesEventManager.createFilesEvent(event.target.files),
      props.compose_controller.compose.attachments_upload,
    )

    file_selection.addItems(props.meo_cloud_controller.uploaded_files);
  }

  const onAbortUpload = async () => {
    await props.meo_cloud_controller.abortUpload(props.compose_controller.compose.attachments_upload);
  }

  const onFileClick = (file) => {
    file_selection.toggle(file.rev, file);
  }

  const onFolderClick = async (file) => {
    file_selection.reset();
    props.meo_cloud_controller.resetUplodedFiles();
    await props.meo_cloud_controller.browse(file.path, get_type.value);
  }

  const onToggleSearchCriteria = (value) => {
    setSearchCriteria(value);
  }

  const onOpenAuthorization = async () => {
    await props.meo_cloud_controller.openAuthorization();
  }

  const onRemoveAuthorization = async () => {
    if (await props.meo_cloud_controller.removeAuthorization() !== true) {
        return;
    }

    modal_component.value.close();
  }

  const onAddFilesToComposer = async () => {
    let response = await props.meo_cloud_controller.getSharedLinks(file_selection.items, link_expiration.value);

    if (response.success !== true) {
      return;
    }

    emit('addFilesToComposer', response.results);
    modal_component.value.close();
  }

  const onAddFilesToMeoCloud = async () => {
    let response = await props.meo_cloud_controller.uploadAttachmentToCloud(props.meo_cloud_attachment);

    if (response.success === false) {
      return;
    }

    modal_component.value.close();
  }

  const onChangeExpiration = (value) => {
    link_expiration.value = value;
  }

  const onWindowMessage = async (event) => {
    if (event.key !== 'mcoa') {
      return;
    }
    await props.meo_cloud_controller.getCloudData(get_type.value);
  }

  const onSearch = async () => {
    if (!search_term.value) {
        return;
    }

    await props.meo_cloud_controller.search(search_term.value, search_criteria.value);
  }

  const onClearSearch = async () => {
    setSearchTerm(null);
    await props.meo_cloud_controller.getCloudData(get_type.value);
  }

  const setSearchTerm = (value) => {
    search_term.value = value;
  }

  const setNewFolderName = (value) => {
    new_folder_name.value = value;
  }

  const setSearchCriteria = (value) => {
    search_criteria.value = value;
  }

  const setFolderCreateVisibilty = (value) => {
    folder_create_visible.value = value;
  }
</script>